export class AgendaException
{
    fecha_desde:any;
    hora_desde:any;
    fecha_hasta :any;
    hora_hasta:any;
    concurrentes:any;
    notas:string;

} 